// src/components/Statistics.js
import React, { useEffect, useState } from 'react';
import styles from '../App.module.css';

const Statistics = () => {
  const [about, setAbout] = useState({});
  const [statistics, setStatistics] = useState([]);
  const [totalEvent, setTotalEvent] = useState(0);
  const [loading, setLoading] = useState(true);
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const fetchHomeAbout =async() => {
    try {
      const response = await fetch(`${baseurl}get-home-about.php`);
      const result = await response.json();
      setAbout(result.data.length > 0 && result.data[0]); // Adjust based on your API response
      setLoading(false)        
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false) 
    } finally {}
  };
  const fetchStaticstics =async() => {
    try {
      const response = await fetch(`${baseurl}count-event.php`);
      const result = await response.json();
      setStatistics(result.data); // Adjust based on your API response 
      setTotalEvent(result.total_count);    
      setLoading(false)   
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false) 
    } finally {}
  };
  useEffect(() => {
    fetchHomeAbout();
    fetchStaticstics();
  }, [])

  return (
    <>
      {
        loading ? (
          <div className="animate-pulse bg-slate-500 w-full">
            <div className="container">
              <div className="w-full bg-slate-500 py-5">
                <div className="h-10 bg-gray-200 mx-auto rounded dark:bg-slate-400 w-1/2 mb-2"></div>
                <div className="h-10 bg-gray-200 mx-auto rounded dark:bg-slate-400 w-1/3"></div>
              </div>
              <div className="grid grid-cols-4 gap-3 pb-5">
                <div className={`${styles.statistics_card} px-4`}>
                  <div className="h-14 bg-gray-200 rounded dark:bg-slate-400 w-10 mb-2"></div>
                  <div className="h-3 bg-gray-200 rounded dark:bg-slate-400 w-3/4"></div>
                </div>
                <div className={`${styles.statistics_card} px-4`}>
                  <div className="h-14 bg-gray-200 rounded dark:bg-slate-400 w-10 mb-2"></div>
                  <div className="h-3 bg-gray-200 rounded dark:bg-slate-400 w-3/4"></div>
                </div>
                <div className={`${styles.statistics_card} px-4`}>
                  <div className="h-14 bg-gray-200 rounded dark:bg-slate-400 w-10 mb-2"></div>
                  <div className="h-3 bg-gray-200 rounded dark:bg-slate-400 w-3/4"></div>
                </div>
                <div className={`${styles.statistics_card} px-4`}>
                  <div className="h-14 bg-gray-200 rounded dark:bg-slate-400 w-10 mb-2"></div>
                  <div className="h-3 bg-gray-200 rounded dark:bg-slate-400 w-3/4"></div>
                </div>
              </div>
              <div className="flex items-center mt-5 bg-white p-4 ps-5 pe-0">
                <div className='w-1/3 px-2'>
                  <div className="h-10 bg-gray-200 dark:bg-slate-400 w-2/4 rounded mb-2"></div>
                  <div className="h-5 bg-gray-200 dark:bg-slate-400 w-3/4 rounded mb-2"></div>
                  <div className="h-5 bg-gray-200 dark:bg-slate-400 w-5/6 rounded mb-2"></div>
                  <div className="h-5 bg-gray-200 dark:bg-slate-400 w-1/5 rounded mb-2"></div>
                  <div className="h-3 bg-gray-200 dark:bg-slate-400 w-3/4 rounded mb-2"></div>
                  <div className="h-3 bg-gray-200 dark:bg-slate-400 w-4/5 rounded mb-2"></div>
                  <div className="h-3 bg-gray-200 dark:bg-slate-400 w-5/6 rounded mb-2"></div>
                  <div className="h-3 bg-gray-200 dark:bg-slate-400 w-2/5 rounded mb-2"></div>
                  <div className="h-8 bg-gray-200 dark:bg-slate-400 w-1/4 mb-2"></div>                  
                </div>
                <div className="w-2/3 text-center">
                  <div className="position-relative" style={{height:"16em"}}>
                    <div className="grid grid-cols-3 w-full position-absolute" style={{top:"-100px"}}>
                      <div className="w-full px-2" data-aos="fade-left" data-aos-delay="400">
                        <div className="flex items-center justify-center w-full h-80 bg-gray-300 rounded dark:bg-gray-700">
                          <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                            <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                          </svg>
                        </div>
                      </div>
                      <div className="w-full px-2" data-aos="fade-left" data-aos-delay="400">
                        <div className="flex items-center justify-center w-full h-80 bg-gray-300 rounded dark:bg-gray-700">
                          <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                            <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                          </svg>
                        </div>
                      </div>
                      <div className="w-full px-2" data-aos="fade-left" data-aos-delay="400">
                        <div className="flex items-center justify-center w-full h-80 bg-gray-300 rounded dark:bg-gray-700">
                          <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                            <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="h-4 bg-gray-200 dark:bg-slate-400 mx-auto w-3/4 rounded mb-2"></div>
                </div>
              </div>
            </div>
          </div>
        ):(          
          <section id="statistics" className="py-20 bg-dark">
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center">            
                  <h2 className="text-5xl font-bold text-white uppercase">Successfully Completed<br/> {totalEvent}+ Projects</h2>
                </div>
                <div className="col-md-12 mt-5 pb-32">
                  <div className="d-flex justify-content-center">
                    {
                      statistics.map((statisticsItem)=>
                        <div className={`text-yellow-400 px-4 ${styles.statistics_card}`}>
                          <h3 className="text-5xl font-bold mb-0">{statisticsItem.total + '+'}</h3>
                          <p className="mb-0 font-bold text-l uppercase">{statisticsItem.event_type}</p>
                        </div>
                      )
                    }                    
                  </div>
                </div>          
              </div>
              <div className="row mt-5 bg-white p-4 ps-5 pe-0">
                <div className="col-md-4">
                  <div>
                    <h2 className="text-5xl font-bold uppercase text-dark">about us</h2>
                    <p className='text-dark mb-1 uppercase font-bold'>corporate event Management company in mumbai - trusted by over 200+ brand</p>
                    <p className='text-dark mb-0 text-sm font-semibold'>We are nationally recognized event planning & organising company based in mumbai. We started with a purpose to provide one stop solutions for all your Event-related worries.</p>
                    <button className="text-xs mt-6 p-2 px-3 uppercase border-yellow-400 border-1 text-black hover:text-white font-semibold hover:bg-transparent bg-yellow-400 transition duration-300">read more</button>
                  </div>
                </div>
                <div className="col-md-8 text-center pe-0">            
                  <div dangerouslySetInnerHTML={{__html: about.description}}/>            
                </div>
              </div>
            </div>
          </section>
        )
      }
    </>
  );
}

export default Statistics;
